import React from "react";
import { Card, Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { RocketOutlined } from "@ant-design/icons";

const FlightCostManagementPage = () => {
    const navigate = useNavigate();

    return (
        <div className="page-container">
            <Card className="data-card">
                <Result
                    icon={<RocketOutlined />}
                    title="航班费用管理"
                    subTitle="此功能正在开发中，敬请期待！"
                    extra={
                        <Button type="primary" onClick={() => navigate("/settlement/leg-cost")}>
                            前往航段费用管理
                        </Button>
                    }
                />
            </Card>
        </div>
    );
};

export default FlightCostManagementPage;

